import { ErrorMessage, FieldProps } from "formik";
import React, { FC, useState } from "react";
import { Eye, EyeSlash } from "react-bootstrap-icons";

type Props = {
  label: string;
  id: string;
  placeholder: string;
} & FieldProps;

export const InputPassword: FC<Props> = ({
  label,
  id,
  placeholder,
  field,
  meta,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="form-floating mb-3">
      <input
        id={id}
        type={showPassword ? "text" : "password"}
        placeholder={placeholder}
        className={`form-control ps-3 ${meta.touched && meta.error ? "is-invalid" : ""}`}
        {...field}
      />
      <label htmlFor={id} className="form-label text-gray ps-3 z-1">
        {label}
      </label>
      <span
        className={`position-absolute ${meta.touched && meta.error ? "eye-error" : "end-0 pe-4"}`}
        style={{ top: "50%", transform: "translateY(-50%)", cursor: "pointer" }}
        onClick={togglePasswordVisibility}
      >
        {showPassword ? (
          <Eye className="text-gray fs-4" />
        ) : (
          <EyeSlash className="text-gray fs-4" />
        )}
      </span>
      <ErrorMessage
        name={field.name}
        component="div"
        className="invalid-feedback"
      />
    </div>
  );
};
